<mat-drawer-container class="component-container" hasBackdrop="true">
    <mat-drawer class="drawer-menu" #menuPanel mode="over">
      <!--<app-sidebar-menu #sidebarMenuComponent (click)="menuPanel.toggle()"></app-sidebar-menu>-->
    </mat-drawer>
    <mat-drawer-content>
      <div class="container-header">
          <mat-toolbar class="toolbar-header-static">
            <div class="menu-container">
                <mat-icon class="icon-header" matTooltip="Atras" [routerLink]="['/']">arrow_back_ios</mat-icon>
            </div>
            <div class="section-name-container">
              <span class="section-title">
                RECUPERAR CONTRASEÑA
              </span>
              <span class="app-title">
                OFICINA VIRTUAL DE
                <span class="app-title-logo">
                  asesores
                </span>
              </span>
            </div>                
          </mat-toolbar>
      </div>      
    </mat-drawer-content>
</mat-drawer-container>
<div class="main-container">
    <div class="forget-content row">
        <form [formGroup]="frmForget">            
            <div class="row" *ngIf="showStep == 1">
                <h1 style="font-family: 'MainFontBold';">RECUPERAR CONTRASEÑA</h1>
                <br>
                <div class="col-12 col-lg-8 column">
                    <div class="col-12 col-lg-6">
                        <mat-label style="font-size: medium;">Ingrese el usuario asignado del asesor</mat-label>
                        <br><br>
                        <mat-form-field style="width: 100%;">
                            <input type="text" matInput placeholder="" formControlName="user" class="input-con-borde">
                            <mat-error></mat-error>
                        </mat-form-field>
                    </div>
                    <br>
                    <div class="col-12 col-lg-6 btn-container">
                        <button class="btn btn-primary" (click)="validateUser()">ENVIAR</button>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="showStep == 2">
                <h1 style="font-family: 'MainFontBold';">NUEVA CONTRASEÑA</h1>
                <br>
                <div class="col-lg-1"></div>
                <div class="col-12 col-lg-5 column">
                    <br><br>
                    <div class="col-12 col-lg-6">
                        <mat-form-field style="width: 100%;">
                            <mat-label>Ingrese tu contraseña</mat-label>
                            <input [type]="hidePassword ? 'password' : 'text'" matInput placeholder="Contraseña" formControlName="password">
                            <mat-icon matSuffix (click)="hidePassword = !hidePassword" class="icon-button-style">{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-lg-6">
                        <mat-form-field style="width: 100%;">
                            <mat-label>Confirme tu contraseña</mat-label>
                            <input [type]="hidePassword2 ? 'password' : 'text'" matInput placeholder="Confirmar contraseña" formControlName="confirmpassword">
                            <mat-icon matSuffix (click)="hidePassword2 = !hidePassword2" class="icon-button-style">{{hidePassword2 ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </mat-form-field>
                    </div>
                    <br>
                    <div class="col-12 col-lg-6 btn-container">
                        <button class="btn btn-primary" (click)="validatePassword()" [disabled]="passwordNoCoincidencia || (frmForget.value.password.length == 0 || frmForget.value.confirmpassword.length == 0)">ACTUALIZAR</button>
                    </div>
                </div>
                <div class="col-12 col-lg-4">
                    <div class="requirement-password-title">
                        <span><b>Su contraseña debe tener:</b></span>
                    </div>
                    <div class="requirement-password-sections">
                        <div class="requirement-icon-container">
                            <mat-icon class="mat-icon-class">{{validatenumber() ? 'check_circle':'radio_button_unchecked'}}</mat-icon>                            
                        </div>
                        <span>Un número</span>
                    </div>
                    <div class="requirement-password-sections">
                        <div class="requirement-icon-container">                            
                            <mat-icon class="mat-icon-class">{{validateSpecialCharacter() ? 'check_circle':'radio_button_unchecked'}}</mat-icon>                            
                        </div>
                        <span>Un carácter especial</span>
                    </div>
                    <div class="requirement-password-sections">
                        <div class="requirement-icon-container">                            
                            <mat-icon class="mat-icon-class">{{validateMinLength() ? 'check_circle':'radio_button_unchecked'}}</mat-icon>
                        </div>
                        <span>Mínimo 8 caracteres</span>
                    </div>
                    <div class="requirement-password-sections">
                        <div class="requirement-icon-container">                            
                            <mat-icon class="mat-icon-class">{{validateUppercase() ? 'check_circle':'radio_button_unchecked'}}</mat-icon>
                        </div>
                        <span>Una letra mayúscula</span>
                    </div>
                    <div class="requirement-password-sections">
                        <div class="requirement-icon-container">                            
                            <mat-icon class="mat-icon-class">{{validateLowercase() ? 'check_circle':'radio_button_unchecked'}}</mat-icon>
                        </div>
                        <span>Una letra minúscula</span>
                    </div>
                </div>
            </div>
        </form>
        <div class="col-10 error-container">
            <span class="alert-text">{{ messageText }}</span>
            <br><br>
            <div class="btn-container" *ngIf="finalButtonText.length > 0">
                <button class="btn btn-primary" (click)="cancel()">{{ finalButtonText }}</button>
            </div>
        </div>
    </div>        
</div>